import { combineReducers } from 'redux-immutable'
import positionListReducer from './position-list-reducer'
import positionCreateReducer from './position-create-reducer'
import positionEditReducer from './position-edit-reducer'
import positionGetReducer from './position-get-reducer'
import positionDeactivateReducer from './position-deactivate-reducer'
import positionExportReducer from './position-export-reducer'
import positionImportReducer from './position-import-reducer'

export default combineReducers({
  positionList: positionListReducer,
  positionCreate: positionCreateReducer,
  positionEdit: positionEditReducer,
  positionGet: positionGetReducer,
  positionDeactivate: positionDeactivateReducer,
  positionExport: positionExportReducer,
  positionImport: positionImportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/position/index.js